import './interactions.css';

export default {};
